// Removed circular re-exports

// Add missing exports that components are trying to import
const staticFaqs = [
  {
    objectId: 'faq1',
    title: 'What is HeresMyInfo?',
    content: JSON.stringify([
      "HeresMyInfo is a contact sharing system. It allows you to truly control and update - in real time - what information people have about you. Whenever any of your profile information changes, it automatically changes for everyone you know, and theirs changes for you, too!",
      "You decide what others have in their contacts about you. Update it at anytime. "
    ])
  },
  {
    objectId: 'faq2',
    title: 'Backing up contacts.',
    content: JSON.stringify([
      "Even the best systems experience issues. We want to make sure that even if a problem occurs, you can always be sure you will not lose any data.",
      "Backing up your contacts is easy with HeresMyInfo. Keep in mind, we only back up the contacts that actually show in your contact list. In the accounts section of your smartphone (both Apple and Android), each account allows turning on or off the contacts stored at that email provider. ",
      "Make sure that the contacts you wish to use and save are showing in your native contact list (the contacts icon that came with your phone) before using the 'Backup Contacts' feature.",
      "Go the drawer icon in the upper right of the HeresMyInfo app on your smart phone. Choose 'Backup Contacts'. ",
      "HeresMyInfo is all about your privacy. Other than what you enter into your profile, we can  never read any of your personal data. Before your contacts leave your phone, they are encypted with a secret paassword onliy you know. ",
      "HeresMyInfo cannot see or restore your information - only you can. Make sure to remember your password. It's the only way to restore your contact information later.",
      "Click the 'Backup and Send' button. Enter the password (remember to save this!!) and click 'Go' ",
      "Two copies of your contacts are stored in encrypted files on our server. The initial backup (the first one you do when you set up your account) and the most recent one you have created. The most recent file is overwritten everytime you backup. If you wish to keep the last backup, go the website and download it before doing another backup (instructions for this are in the 'Restoring your contacts' section below). "
    ])
  },
  {
    objectId: 'faq3',
    title: 'Restoring contacts.',
    content: JSON.stringify([
      "Restore to your Gmail account contacts.",
      "Restore to OTHER accounts contacts."
    ])
  },
  {
    objectId: 'faq4',
    title: 'Oh, no, I just logged in with a social account and all my stuff is gone!',
    content: JSON.stringify([
      "Logging in with a social account not already in your profile automatically creates a new account. This makes it quick and easy when you invite someone new, but can cause problems.",
      "To fix it, check the email account associated with the social account you used when you created the unintended account. Sign in on the web, go to 'My Profile'",
      "We've done what we could to prevent you from accidentally making a second account - but it can still happen.",
      "Don't worry - it's easy to fix.",
      "First, let's delete this duplicate HeresMyInfo account. Unfortunately, if you connected with anyone, you'll need to re-invite them again from your real account. Make sure to note their email addresses so you send new invites.",
      "To delete this duplicate account, go to the Home screen (click on the HeresMyInfo logo in the upper-left corner of your browser, then choose the 'Delete Account button at the bottom.",
      "THIS IS PERMANENT. We cannot restore your account after this is complete.",
      "You will need to go through a confirmation process.",
      "Log in with the account you used when you set signed up. We advise you to add the additional social account to your profile as soon as possible to prevent this from happening in the future, and to make it easier to login.",
      "You can login to your HeresMyInfo account with ANY verified social account or email address you add to your profile."
    ])
  }
];

export const loadFaqs = () => (dispatch) => {
  dispatch({ type: 'LOAD_FAQS_SUCCESS', payload: staticFaqs });
  return Promise.resolve(staticFaqs);
}
export const createFaq = () => () => Promise.reject(new Error('Not implemented'))
export const updateFaq = () => () => Promise.reject(new Error('Not implemented'))
export const removeFaq = () => () => Promise.reject(new Error('Not implemented'))

const initialState = {
    loading: false,
    error: null,
    list: []
}

const faqReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOAD_FAQS_SUCCESS':
            return { ...state, list: action.payload, loading: false }
        default:
            return state
    }
}

export default faqReducer
